import { administrationRequests } from "api/administrationApi";
import {
  DISCIPLINES,
  CURRICULUMS,
  FOREIGN_LANGUAGES,
  INTERNSHIPS,
  PRACTICES,
  SPECIALITIES,
  STATE_EXAMS,
} from "utils/constants";
import { createExporter } from "utils/createExporter";

const NAME_COLUMNS = [
  { key: "nameBg", label: "име на български" },
  { key: "nameEn", label: "име на английски" },
];

const CURRICULUMS_COLUMNS = [
  { key: "name", label: "заглавие" },
  { key: "validFrom", label: "валиден от" },
  { key: "degree", label: "квалификационна степен" },
  { key: "speciality", label: "специалност" },
];

const DISCIPLINES_COLUMNS = [
  ...NAME_COLUMNS,
  { key: "category", label: "категория" },
  { key: "parent", label: "главна дисциплина" },
  { key: "departments", label: "катедра" },
  { key: "isRequiredForAdvance", label: "може да се запише условно" },
  { key: "hasPracticalExam", label: "има практически изпит" },
];

const INTERNSHIPS_COLUMNS = [...NAME_COLUMNS, { key: "type", label: "тип стаж" }];

const categoryNames = {
  1: "Основна",
  2: "Спорт",
  3: "Чужд език",
};

const internshipsType = {
  1: "Летен",
  2: "Пред-дипломен",
};

export const EducationsExporter = type => {
  const columnsMap = {
    [CURRICULUMS]: CURRICULUMS_COLUMNS,
    [DISCIPLINES]: DISCIPLINES_COLUMNS,
    [FOREIGN_LANGUAGES]: NAME_COLUMNS,
    [INTERNSHIPS]: INTERNSHIPS_COLUMNS,
    [PRACTICES]: NAME_COLUMNS,
    [SPECIALITIES]: NAME_COLUMNS,
    [STATE_EXAMS]: NAME_COLUMNS,
  };

  const defaultMapping = record => ({
    ...record,
  });

  const mapperMap = {
    [CURRICULUMS]: record => ({
      ...record,
      speciality: record.speciality?.name,
      degree: record.degree?.name,
    }),

    [DISCIPLINES]: record => ({
      ...record,
      isRequiredForAdvance: record.isRequiredForAdvance ? "Да" : "Не",
      hasPracticalExam: record.hasPracticalExam ? "Да" : "Не",
      departments: Array.isArray(record.departments) ? record.departments.map(d => d?.name).join(", ") : "",
      category: categoryNames[record.category],
      parent: record.parent?.name,
    }),

    [INTERNSHIPS]: record => ({
      ...record,
      type: internshipsType[record.type],
    }),
  };

  const relationsMap = {
    [CURRICULUMS]: [
      {
        source: "specialityId",
        target: administrationRequests.getSpecialitiesSelect(),
        name: "speciality",
      },
      {
        source: "degreeId",
        target: administrationRequests.getDegreesSelect(),
        name: "degree",
      },
    ],

    [DISCIPLINES]: [
      {
        source: "departmentIds",
        target: administrationRequests.getDepartmentsSelect(),
        name: "departments",
      },
      {
        source: "parentId",
        target: administrationRequests.getDisciplinesSelect(),
        name: "parent",
      },
    ],
  };

  const columns = columnsMap[type];

  const mapper = mapperMap[type] || defaultMapping;

  const relations = relationsMap[type] || [];

  const fileName = type.replace(/[-/]/g, "_");

  return createExporter(`educations_${fileName}.xlsx`, columns, mapper, relations);
};
